const cashJS = require("cash-dom");

export const ANOPENSCROLL_FONT_FAMILY = "anopenscrollregular";
export const DEFAULT_CLIENT_FONT_FAMILY = "Share Tech Mono";

export function ApplyBodyFont(useAnopenscrollFont: boolean) {
    const fontFamily = useAnopenscrollFont
        ? ANOPENSCROLL_FONT_FAMILY
        : DEFAULT_CLIENT_FONT_FAMILY;
    const shouldCompensateForIos = useAnopenscrollFont && IsIosDevice();
    const body = cashJS("body");

    body.css("font-family", fontFamily);
    body.css("font-size", shouldCompensateForIos ? "18px" : "");
    body.css("line-height", shouldCompensateForIos ? "1.05" : "");
    body.css("-webkit-text-size-adjust", "100%");
    body.css("text-size-adjust", "100%");
}

function IsIosDevice(): boolean {
    if (typeof navigator === "undefined") {
        return false;
    }

    const platform = navigator.platform || "";
    const userAgent = navigator.userAgent || "";

    return (
        /iPad|iPhone|iPod/.test(userAgent) ||
        (platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
}
